module.exports = __webpack_public_path__ + "static/media/Team10Logo - Dylan de Souza.1fa0747a.jpg";